<script setup>
import { useAuthStore } from "@/stores/authStore";

const authStore = useAuthStore();

authStore.logoutUser();
</script>
